import MasterModal from 'components/organisms/masterModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseForm from 'components/atoms/base-form';
import { IntroCallForm } from 'components/organisms/device-troubleshoot-templates/templates/deviceTroubleshootForm';
import FormItemWrapper from 'components/molecules/rpm-alert-assessment/formItemWrapper';

import s from '../../styles.module.scss';
import { useIntroCall } from '../../hooks/use-intro-call-modal';
import { useStoreModalValue } from '../../hooks/use-store-modal-value';

import type { IIntroCallModalProps } from '../../types';
import type { FC } from 'react';

const IntroCallModal: FC<IIntroCallModalProps> = ({
  isOpen,
  handleSubmit,
  closeModal,
  whichPerson,
  otherPerson,
  patientGuid,
}) => {
  const { t } = useTranslation();
  const { initialValues, onSaveForm } = useIntroCall({
    closeModal,
    handleSubmit,
    whichPerson,
    otherPerson,
  });

  const type = 'min';

  type TInitialValues = typeof initialValues;
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<TInitialValues>({
      modalName: `introCall_${patientGuid}`,
    });

  const formik = useFormik({
    initialValues: parsedData ?? initialValues,
    onSubmit: (data) => {
      setModalValuesToStorage(data);
      onSaveForm(data);
    },
    validateOnChange: false,
  });

  const onSave = () => {
    formik.submitForm();
  };

  return (
    <>
      <MasterModal
        isOpen={isOpen}
        toggle={closeModal}
        title={t('labels.RPMSpecialistTemplate')}
        onSave={onSave}
        size="medium"
        dataCy="RPMSpecialistTemplate"
      >
        <BaseForm formik={formik}>
          <div className={s.wrapper}>
            {IntroCallForm.map((formItem, index) => {
              return (
                <FormItemWrapper
                  formik={formik}
                  index={index}
                  formItem={formItem}
                  type={type}
                  requiredSymptomFields={[]}
                />
              );
            })}
          </div>
        </BaseForm>
      </MasterModal>
    </>
  );
};

export default IntroCallModal;
